import {store} from "../../redux";
import {addErrorSnack} from "../../../domain/BarsENV/snack/store/slice";

export const snackError = (message: string | { message: string, invalidToken?: boolean }) => store.dispatch(addErrorSnack(message));
